module.exports = __webpack_public_path__ + "img/feature3.e1458c0.png";